import React from "react";
const DataContext = React.createContext<{
  userId: number;
  answers: Answer[];
  setAnswers: (value: React.SetStateAction<Answer[]>) => void;
  carbonAnswers: Answer[];
  setOrgInfoAnswers: (value: React.SetStateAction<Answer[]>) => void;
  orgInfoAnswers: Answer[];
  template: Template;
  orgInfo: OrgInfo;
}>({
  answers: [],
  setAnswers: (value: React.SetStateAction<Answer[]>) => {},
  userId: -1,
  carbonAnswers: [],
  orgInfoAnswers: [],
  setOrgInfoAnswers: (value: React.SetStateAction<Answer[]>) => {},
  template: { envTemplate: {}, envTemplateStyles: {} },
  orgInfo: {
    id: 0,
    city_council_id: 0,
    user_id: 0,
    company_name: "",
    address: "",
    postcode: "",
    types: [],
    consent: false,
  },
});
export const DataProvider = DataContext.Provider;
export default DataContext;
